import { userSettingsStore } from '@pascal/pascal-core/shared/core/store/userSettingsStore';
import { GameDrawerBase } from './gameDrawer.base';
import { gameLayers } from '../../../enums/gameLayers';
import { webConfigs } from '../../../core/pixi/configs';
import { resourceHelper } from '../../../core/pixi/cashe/ResourceHelper';
import { GameApplicationType } from '../../../enums/GameApplicationType';
import { ResourcesSharedNames } from '../../../core/pixi/resources/resources';

class GameSceneDrawer extends GameDrawerBase {
  constructor(config) {
    super();
    this.config = config;
    this.shootSmokeTexture = null;
    this.crazyWormIdleLongTexture = null;
    this.applications = {
      [GameApplicationType.Web]: this.createApplication(webConfigs.applicationConfigs),
    };
    this.isWin = null;
    this.tweening = [];
    this.isShootPlay = false;
  }

  setupCrazyWormIdleLong() {
    this.crazyWormIdleLongTexture = this.createSpine(
      resourceHelper.get(ResourcesSharedNames.crazyWormIdleLong)
    );
    const { scale, x, y } = this.config.gameCharacterConfigs.crazyWormSceneConfigs.crazyWormConfig;
    this.crazyWormIdleLongTexture.scale.set(scale);
    this.setPosition(this.crazyWormIdleLongTexture, { x, y });
    this.crazyWormIdleLongTexture.state.clearTrack();
    this.crazyWormIdle();
    this.layers[gameLayers.CrazyWormScene].addChild(this.crazyWormIdleLongTexture);
  }

  crazyWormIdle() {
    if (userSettingsStore.isAnimationOn) {
      this.crazyWormIdleLongTexture.state.setAnimation(0, 'idle_blink', true);
    }
  }

  crazyWormShoot() {
    this.crazyWormIdleLongTexture.state.clearTrack();
    this.crazyWormIdleLongTexture.state.setAnimation(0, 'shoot00', true);
    setTimeout(() => this.crazyWormIdle(), 1320);
  }

  setupShootSmoke() {
    this.shootSmokeTexture = this.createSpine(resourceHelper.get(ResourcesSharedNames.shootSmoke));
    const { scale, x, y } = this.config.gameCharacterConfigs.crazyWormSceneConfigs.shootSmokeConfig;
    this.shootSmokeTexture.scale.set(scale);
    this.setPosition(this.shootSmokeTexture, { x, y });
    this.layers[gameLayers.ShootSmokeScene].addChild(this.shootSmokeTexture);
  }

  shootSmokeWin() {
    this.shootSmokeTexture.state.clearTrack();
    this.shootSmokeTexture.state.setAnimation(0, 'win', false);
  }

  shootSmokeLoose() {
    this.shootSmokeTexture.state.clearTrack();
    this.shootSmokeTexture.state.setAnimation(0, 'loose', false);
  }

  clearAllGameTracks() {
    this.layers[gameLayers.CrazyWormScene].removeChildren();
    this.layers[gameLayers.ShootSmokeScene].removeChildren();
    this.layers[gameLayers.CrazyWormScene].removeAllListeners();
    this.layers[gameLayers.ShootSmokeScene].removeAllListeners();
  }

  async execute(layers, configs) {
    this.layers = layers;
    this.config = configs;
    this.setupShootSmoke();
    this.setupCrazyWormIdleLong();
  }
}

export const webGameSceneDrawer = new GameSceneDrawer();
